import { CustomMultiFilterButton } from "../button/CustomMultiFilterButton";
import Translate from "../../translate/Translate";

export default function CategoryFilterButton({ currentValues, setValues, type }) {
    let values;
    let multiText;
    if (type === "userManagement") {
        values = [
            { label: Translate("common.allStatus"), value: "all" },
            { label: Translate("marketing.status.enable"), value: "Enable" },
            { label: Translate("marketing.status.disable"), value: "Disable" },
        ];
    } else if (type === "ticket") {
        values = [
            { label: Translate("ticket.status.allStatus"), value: "all" },
            { label: Translate("ticket.status.registered"), value: "registered" },
            { label: Translate("ticket.status.carriedOut"), value: "carriedOut" },
            { label: Translate("ticket.status.forwardTheMatter"), value: "forwardTheMatter" },
            { label: Translate("ticket.status.closed"), value: "closed" },
        ];
    } else if (type === "device") {
        values = [
            { label: "All Device", value: "all" },
            { label: "Washer", value: "Washer" },
            { label: "Dryer", value: "Dryer" },
            { label: "Combo", value: "Combo" },
        ];
    } else if (type === "deviceStatus") {
        values = [
            { label: Translate("common.allStatus"), value: "all" },
            { label: "Error", value: "error" },
            { label: "Standby", value: "standby" },
            { label: "In Use", value: "inUse" },
            { label: "Offline", value: "offline" },
        ];
    } else if (type === "storeList") {
        values = [
            { label: Translate("common.allStatus"), value: "all" },
            { label: Translate("store.status.open"), value: "Open" },
            { label: Translate("store.status.closed"), value: "Closed" },
        ];
    } else if (type === "marketing") {
        values = [
            { label: Translate("common.allStatus"), value: "all" },
            { label: Translate("marketing.status.enable"), value: "Enable" },
            { label: Translate("marketing.status.disable"), value: "Disable" },
        ];
    }

    if (type === "device") {
        multiText = "Devices";
    } else {
        multiText = "Status";
    }

    return (
        <CustomMultiFilterButton
            icon={currentValues.includes("all") ? "filter" : "filter_active"}
            currentValues={currentValues}
            setValues={setValues}
            values={values}
            multiText={multiText}
            openedLeftSide={type === "deviceStatus"}
        />
    );
}
